import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { AppButton, Typography } from "@libs/zapi-ui/custom";

type TPreviewEmptyProps = {
  onGenerateOutline: () => void;
  onGeneratePreview: () => void;
  hasSlides: boolean;
  allowRegeneration: boolean;
};

export function PreviewEmpty({
  onGenerateOutline,
  hasSlides,
  onGeneratePreview,
  allowRegeneration
}: TPreviewEmptyProps) {
  if (!hasSlides) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center">
        <Typography variant="heading6" className="mb-3">
          Start with the Edit Outline
        </Typography>
        <Typography variant="body2" color="zinc600" className="mb-6 text-center">
          Start by generating a slides outline. Then generate the <br /> preview to create your presentation.
        </Typography>
        <AppButton
          onClick={onGenerateOutline}
          className="[&_svg>path]:fill-white"
          startAdornment={<InnoveraIcon width={16} height={16} />}
        >
          <Typography variant="label2">Generate Presentation Outline</Typography>
        </AppButton>
      </div>
    );
  }

  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      {/* <img src={placeholderImage} width={560} height={278} alt="" /> */}
      <div className="flex flex-col items-center justify-center">
        <Typography variant="heading5" className="mb-3">
          Turn Your Outline into Slides
        </Typography>
        <Typography variant="body2" color="zinc700" className="mb-6 text-center">
          Convert your slides outline into a complete presentation <br /> with visuals, charts, and layouts.
        </Typography>
        <AppButton
          onClick={onGeneratePreview}
          disabled={!allowRegeneration}
          className="[&_svg>path]:fill-white"
          startAdornment={<InnoveraIcon width={16} height={16} />}
        >
          <Typography variant="label2">Generate Preview</Typography>
        </AppButton>
      </div>
    </div>
  );
}
